<div class="p-dialog-body">
    <p class="fs-15 color-gray-800 mb-20">{{ description}}</p>
    <div class="mb-20">
        <h2 class="fs-15 mb-0 color-gray-800 fw-regular">{{title}}</h2>
        <label class="fs-15 fw-semibold color-gray-900 d-block">{{name}}</label>
    </div>
    <p class="color-gray-800 mb-0 fs-15">{{'common.messages.confirmation.confirm_continue' | t}}</p>
</div>
<div class="p-dialog-footer border-top-0">
    <p-button
        label="{{'common.actions.buttons.cancel' | t}}"
        severity="secondary"
        variant="text"
        (onClick)="closeModal(false)"
    ></p-button>
    <p-button
        label="Discard Changes"
        severity="primary"
        (onClick)="closeModal(true)"
    ></p-button>
</div>